import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Message } from 'semantic-ui-react';
import GetCertificate from '../../CertificateRequest/GetCertificate';

export default class NewExternalStudentCertificate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const mobilityTypeKey = this.props.student && this.props.student.mobilityType && this.props.student.mobilityType._key;
        const isNonCycleProgram = mobilityTypeKey === 'non_cycle';

        return (
            <div>
                <Fragment>
                    <Message>
                        {isNonCycleProgram ? (
                            <Fragment>
                                <p><FormattedMessage id="externalStudent.documentsInfoNonCycleIntro" /></p>
                                <ul>
                                    <li><FormattedMessage id="externalStudent.documentsInfoNonCycleBullet1" /></li>
                                    <li><FormattedMessage id="externalStudent.documentsInfoNonCycleBullet2" /></li>
                                    <li><FormattedMessage id="externalStudent.documentsInfoNonCycleBullet3" /></li>
                                    <li><FormattedMessage id="externalStudent.documentsInfoNonCycleBullet4" /></li>
                                </ul>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <p><FormattedMessage id="externalStudent.documentsInfoCycleIntro" /></p>
                                <ul>
                                    <li><FormattedMessage id="externalStudent.documentsInfoCycleBullet1" /></li>
                                    <li><FormattedMessage id="externalStudent.documentsInfoCycleBullet2" /></li>
                                </ul>
                            </Fragment>
                        )}
                    </Message>
                    <GetCertificate
                        closeGetRequestMode={() => this.setState({
                            getCertificate: false, loading: false, firstName: '', lastName: '', index: '', show: false
                        })}
                        student={this.props.student}
                        studentCertificate
                        externalStudent
                    />
                </Fragment>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/NewExternalStudentCertificate.js